import http from '@/utils/http'
// 
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = "/"

// 轮播图列表
export function getBannerList(params){
    return http.get('/banner/carousel/portal/list',params)
}
// 上传图片
export function uploadphoto(data){
    return http.post('/common/upload',data)
}
// 直播列表
export function getLiveList(params){
    return http.get('/live/liveInfo/list',params)
}

// 当前直播列表
export function getnowLiveList(params){
    return http.get('/live/liveInfo/getNowLiveList',params)
}

// 直播回看列表
export function getoverLiveList(params){
    return http.get('/live/liveInfo/getOverLiveList',params)
}

// 直播详情
export function getLiveDetail(id){
    return http.get('/live/liveInfo/portal/'+id)
}

// 直播大家在看
export function getLiveSign(id, params){
    return http.get('/live/liveSignIn/selectLiveSignInUserList/'+id, params)
}


// 课例展评反馈
export function getkeKuiList(params){
    return http.get('/videoBusiness/businessCommentsExpand/getCommentsBySubjectId',params)
}

// 查询是否能查看直播
export function isSeelive(liveId){
    return http.get('/activity/joinuser/selectTApiActivityUserByLiveId/'+liveId)
}

// 刷新直播二维码
export function refreshLiveCode(liveId){
    return http.get('/live/liveInfo/refresh/'+liveId)
}




// WEBPACK FOOTER //
// ./src/api/home.js